import { Checkbox, Flex } from "antd";
import styled from "styled-components";

export const StyledCheckbox = styled(Checkbox)`
    && {
        border-bottom: 1px solid ${({ theme }) => theme.secondaryBorderColor};
        padding-bottom: 8px;
        width: 100%;

        .ant-checkbox-inner {
            width: 32px;
            height: 32px;
            border-radius: 6px;
            border-width: 2px;

            &::after {
                inset-inline-start: 28%;
                top: 48%;
                width: 8.5px;
                height: 16px;
            }
        }

        .ant-checkbox-checked .ant-checkbox-inner {
            background-color: ${({ theme }) => theme.colors.primary};
            border-color: ${({ theme }) => theme.colors.primary};
        }

        .ant-checkbox-label {
            padding: 0;
            flex-grow: 1;
            padding-left: 16px;
        }
    }
`;

export const StyledContentBody = styled(Flex)`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    width: 100%;
    gap: 16px;
`;

export const StyledContentList = styled(Flex)`
    margin-top: 16px;
    height: 100%;
    max-height: 100%;
    width: 100%;
    overflow-y: auto;
    min-height: 0;
`;

export const StyledContentListContainer = styled(Flex)`
    height: 100%;
    overflow: hidden;
`;
